// extracted by mini-css-extract-plugin
export var dropdown = "navigation-module--dropdown--f8ce9";
export var dropdownButton = "navigation-module--dropdownButton--32a58";
export var dropdownContent = "navigation-module--dropdownContent--881cb";
export var dropdownLink = "navigation-module--dropdownLink--fa90a";
export var lastDropdown = "navigation-module--last-dropdown--57190";
export var link = "navigation-module--link--5bb59";
export var navigation = "navigation-module--navigation--539bd";